const portfolios = [
    {
        id:Date.now(),
        name: "Vision Fire and Security Systems",
        img:process.env.PUBLIC_URL + './image/projects/16.jpg',
        url : "https://findnvibe.com/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "Find N Vibe",
        img:process.env.PUBLIC_URL + './image/projects/13.png',
        url : "https://visionfiresecuritysystems.com/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "KTR Machinery",
        img:process.env.PUBLIC_URL + '/image/projects/14.png',
        url : "https://ktrmachinery.com/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "Food",
        img:process.env.PUBLIC_URL + '/image/projects/1.jpg',
        url : "https://ashish-food.netlify.app/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Memory Game",
        img:process.env.PUBLIC_URL + './image/projects/15.png',
        url : "https://darling-pie-08cd06.netlify.app/",
        type: 'typescript'
    },
    {
        id:Date.now(),
        name: "Organic",
        img:process.env.PUBLIC_URL + '/image/projects/11.jpg',
        url : "https://ashish-organic.netlify.app/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "Fooda",
        img:process.env.PUBLIC_URL + '/image/projects/3.jpg',
        url : "https://ashish-fooda.netlify.app/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Fitclick",
        img:process.env.PUBLIC_URL + '/image/projects/9.jpg',
        url : "https://ashish-fitclick.netlify.app/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Gym Management",
        img:process.env.PUBLIC_URL + './image/projects/10(1).jpg',
        url : "https://gym-management-24dae.firebaseapp.com/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "Flipkart-Clone",
        img:process.env.PUBLIC_URL + '/image/projects/12.jpg',
        url : "https://ashish-flipkart-clone.netlify.app/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "Online Payment",
        img:process.env.PUBLIC_URL + '/image/projects/4.jpg',
        url : "https://ashish-onlinepayment.netlify.app/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Covid",
        img:process.env.PUBLIC_URL + '/image/projects/2.jpg',
        url : "https://covid19-ashish.netlify.app/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Portfolio",
        img:process.env.PUBLIC_URL + '/image/projects/8.jpg',
        url : "https://aashishportfolio.netlify.app/",
        type: 'react'
    },
    {
        id:Date.now(),
        name: "Mobile",
        img:process.env.PUBLIC_URL + '/image/projects/6.jpg',
        url : "https://ashish8689.github.io/mobile/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Star Cricket Academy",
        img:process.env.PUBLIC_URL + '/image/projects/7.jpg',
        url : "https://ashish-cricketacademy.netlify.app/",
        type: 'static'
    },
    {
        id:Date.now(),
        name: "Armed Defence",
        img:process.env.PUBLIC_URL + '/image/projects/5.jpg',
        url : "http://armeddefence.epizy.com/",
        type: 'static'
    }
]


export default portfolios;